export default __webpack_public_path__ + "static/media/placeholder_business02-nl-mobile.58a450e9.png";